import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import styles from "../../styles/login/login.module.css";
import loginUserClient from '../../utility/features/api_clients/login/loginUserClient';
import { setUserDetails } from '../../reduxStore/login/loginSlice';

const Login = () => {
    const dispatch = useDispatch();

    const [form, setForm] = useState({
        UserName: "",
        password: "",
    });
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();


    const handleForm = (e = null, type) => {
        let value = e.target.value;
        let formObj = {
            ...form,
            [type]: value
        }
        setForm(formObj);
    }

    const handleLogin = async (e) => {
        e.preventDefault();

        const payload = {
            email: form.UserName?.trim(),
            password: form.password?.trim(),
        };

        if (!payload.email || !payload.password) {
            setErrorMessage("Email and password are required.");
            return;
        }

        setErrorMessage("");

        try {
            const result = await loginUserClient(payload);

            if (result?.status !== 200) {
                setErrorMessage("Login failed. Please try again.");
                return;
            }

            const { status, data } = result ?? {};

            if (status === 200 && data?.messageCode !== 20000) {
                const user = data[0] || null;
                const roleID = user?.roleID;
                const roleName = user?.roleName;
                const branchID = user?.branches && user.branches.length > 0 ? user.branches : [];

                if (user) {
                    //user = JSON.stringify(user);
                    localStorage.setItem("user", JSON.stringify(user));
                    dispatch(setUserDetails(user));
                }

                if (roleName === "Admin" && roleID === 1) {
                    navigate("/configure/dashboard", { replace: true });
                } else if (roleName === "Branch Manager" && roleID === 2 && branchID.length > 0) {
                    navigate("/configure/branch-manager", { replace: true });
                } else {
                    setErrorMessage("Unexpected response from server.");
                    navigate("/configure", { replace: true });
                }
            } else if (data.messageCode === 20000) {
                setErrorMessage(data.message || "Invalid credentials.");
                console.log("Error logging in user:", data.message);
            } else {
                setErrorMessage(data.message || "Unexpected response from server.");
            }
        }
        catch (err) {
            console.error("Error logging in:", err);
        } finally {
        }
    };

    return (
        <section className={styles["login-section"]}>
            <div className="container">
                <div className="row justify-content-center align-items-center">
                    <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
                        <div className={`${styles["admin-login"]} ${styles["login-bg"]}`}>
                            <div className={styles["login-head"]}>
                                <h1> Scheduler Admin Login</h1>
                                <span className="d-inline-block gfs-20 gfw-3 mb-24 text-dark">Enter your username and password to sign in</span>
                            </div>
                            <div className={styles["login-form"]}>
                                <form noValidate>
                                    {errorMessage !== "" && <p className='p-1 text-danger'>{errorMessage}</p>}
                                    <div className="form-group">
                                        <input type="text" id="username" className={`form-control`} placeholder="Username or email" autoComplete='on' aria-label="Enter your username"
                                            value={form.UserName} onChange={(e) => handleForm(e, "UserName")} />
                                    </div>

                                    <div className="form-group">
                                        <input type="password" id="password" className={`form-control`} placeholder="Password" autoComplete='on' aria-label="Enter your password"
                                            value={form.password} onChange={(e) => handleForm(e, "password")} />
                                    </div>

                                    <button type="submit" className={`btn ${styles["login-btn"]} btn-primary`}
                                        onClick={(e) => handleLogin(e)}
                                    >Login</button>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    )
}

export default Login;